import { Check } from "../../../../Icons";
import style from "./index.module.css";

const Equipment = ({ equipment }: ComponentPropsType) => {
  return (
    <div className={`${style.all_equipment} row`}>
      {equipment.map((item) => (
        <div
          key={item.id}
          className={`${style.single_equipment} col-md-4 col-6`}
        >
          <Check width="17" height="17" color="#2f2f2f" />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default Equipment;

export type EquipmentType = {
  id: number;
  icon: string;
  name: string;
  value: string;
};

type ComponentPropsType = {
  equipment: EquipmentType[];
};
